import * as apiClient from './httpCommon';
import { dynamicUrl } from "../helper/dynamicUrls";

export const clientEmailNotification = async (data) => (await apiClient.postAPICall(dynamicUrl.updateUser, data)).data;
export const fetchAllClient = async (data) => (await apiClient.postAPICall(dynamicUrl.fetchAllClients, data)).data;
export const fetchIndividualUser = async (data) => (await apiClient.postAPICall(dynamicUrl.fetchIndividualUser, data)).data;
export const fetchIndividualClient = async (data) => (await apiClient.postAPICall(dynamicUrl.fetchIndividualClient, data)).data;
export const updateClientComponentNames = async (data) => (await apiClient.postAPICall(dynamicUrl.updateClientComponentNames, data)).data;
export const updateClientSpocDetails = async (data) => (await apiClient.postAPICall(dynamicUrl.updateClientSpocDetails, data)).data;
